import { backendUrl } from '@shared/constants/urls/appUrls';
import { fetchWithAuth } from '@shared/utils/auth';

//Получение информации о монете по coinId
export const apiGetCoinById = async (coinId) => {
  const url = `${backendUrl}/api/coins/${coinId}`;
  const options = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  };

  try {
    const response = await fetchWithAuth(url, options);
    if (!response.ok) {
      throw new Error(`Сетевая ошибка при получении данных монеты: HTTP error! Status: ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    console.error('Ошибка при получении данных монеты:', error);
    throw error;
  }
};